(function () {
  function initSection(root) {
    const mainMedia = root.querySelector('[data-cop-main-media]');
    const thumbs = root.querySelectorAll('[data-cop-thumb]');
    const thumbsContainer = root.querySelector('[data-cop-thumbs]');

    const prevBtn = root.querySelector('[data-thumb-prev]');
    const nextBtn = root.querySelector('[data-thumb-next]');

    if (!mainMedia || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const index = thumb.dataset.mediaIndex;

        const template = root.querySelector(
          '[data-cop-template="' + index + '"]'
        );

        if (!template) return;

        mainMedia.classList.add('is-changing');

        setTimeout(() => {
          mainMedia.innerHTML = template.innerHTML;

          requestAnimationFrame(() => {
            mainMedia.classList.remove('is-changing');
          });
        }, 350);

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });

        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');

        thumb.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      });
    });

    if (prevBtn && thumbsContainer) {
      prevBtn.addEventListener('click', function () {
        thumbsContainer.scrollBy({
          left: -300,
          behavior: 'smooth'
        });
      });
    }

    if (nextBtn && thumbsContainer) {
      nextBtn.addEventListener('click', function () {
        thumbsContainer.scrollBy({
          left: 300,
          behavior: 'smooth'
        });
      });
    }
  }

  function boot() {
    document
      .querySelectorAll('.chill__out[data-section-id]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector(
      '.chill__out[data-section-id]'
    );

    if (section) {
      initSection(section);
    }
  });
})();